export default "__VITE_ASSET__BVgo9tBG__"